<template>
  <q-card class="inhdialog-container">
    <div class="inhdialog-header">
      <h1 class="dialog_name">{{ $t('edit_warehouses_full') }}</h1>
      <q-btn
        flat
        round
        icon="close"
        size="md"
        color="accent"
        :title="$t('close_label')"
        @click="close"
      />
    </div>

    <div class="dialog_content" style="overflow: hidden">
      <div class="field-group">
        <div class="field-group__row no-wrap justify-left q-my-xs">
          <div
            style="text-decoration: underline"
            class="cursor-pointer"
            @click="addStorage"
          >
            + {{ $t('warehouse') }}
          </div>
          <div
            style="text-decoration: underline"
            class="cursor-pointer q-ml-xl"
            @click="addStorageGroup"
          >
            + {{ $t('warehouse_group') }}
          </div>
        </div>
      </div>

      <div class="field-group q-mt-sm">
        <div class="row no-wrap" style="align-items: baseline">
          <q-input
            outlined
            dense
            ref="header_search_input"
            color="white"
            class="thin-input q-my-auto"
            style="min-width: 400px; margin-left: -5px;"
            v-model="search_filter"
            hide-bottom-space
            clearable
            clear-icon="arrow_back"
            :placeholder="$t('search_label')"
            debounce="300"
            @clear="search_filter = ''"
          />
          <q-icon color="accent" size="sm" name="search" />
        </div>
      </div>

      <dnd-provider :backend="HTML5Backend" :context="_WINDOW_">
        <div class="dnd-table-tabs" style="max-height: calc(100% - 46px); height: calc(100% - 46px); min-height: calc(100% - 46px)">
          <!-- Заголовки вкладок -->
          <div class="tab-headers" ref="tabheaders">
            <div
              v-for="(tab, tab_idx) in tabs"
              :key="tab.id"
              :class="['tab-header', { active: activeTab === tab.id }]"
              @click.stop="activeTab = tab.id"
            >
              <drop-zone :target-id="tab.id" @moveRow="moveRow">
                <div class="row no-wrap display-buttons-on-hover" style="align-items: start;">
                  <native-input
                    :ref="(el) => { inputs[tab_idx] = el }"
                    :model-value="tab.label"
                    :allow-line-break="false"
                    @update:modelValue="
                      (newname) => {
                        if (tab.label != newname) {
                          onRenameGroup(tab.dbId, newname);
                        }
                      }
                    "
                  />
                  <div class="q-ml-xs" style="font-size: 14px; margin-top: 3px;">({{ tab.rows_count }})</div>
                  <q-btn
                    v-if="tab.dbId > 0"
                    flat
                    dense
                    round
                    size="9px"
                    :icon="editIconName"
                    color="grey-6"
                    class="q-ml-xs"
                    @click.stop="focusInput(tab_idx)"
                  />
                  <q-btn
                    v-if="tab.dbId > 0"
                    flat
                    dense
                    round
                    size="9px"
                    :icon="deleteIconName"
                    color="grey-6"
                    @click.stop
                  >
                    <q-menu>
                      <q-card>
                        <q-card-section class="row items-center">
                          <q-avatar
                            icon="delete"
                            size="md"
                            color="grey"
                            text-color="white"
                          />
                          <span class="q-ml-sm">
                            {{ $t("sure_delete") }}
                          </span>
                        </q-card-section>

                        <q-card-actions align="right">
                          <q-btn
                            size="sm"
                            flat
                            :label="$t('cancel')"
                            color="dark"
                            :ref="'cancelbtn'"
                            v-close-popup
                          />
                          <q-btn
                            size="sm"
                            flat
                            :label="$t('remove')"
                            autofocus
                            color="dark"
                            :ref="'okbtn'"
                            @click="onDeleteGroup(tab.dbId)"
                            v-close-popup
                          />
                        </q-card-actions>
                      </q-card>
                    </q-menu>
                  </q-btn>
                </div>
              </drop-zone>
            </div>
          </div>
          
          <div
            class="inner_container"
            :style="`overflow: auto; height: calc(100% - ${46+(this.$refs.tabheaders ? this.$refs.tabheaders.offsetHeight : 0)}px)`"
          >
            <!-- Таблица -->
            <div class="tab-content">
              <table class="dialog-table">
                <thead>
                  <tr>
                    <th>{{ $t('warehouse_name') }}</th>
                    <th>{{ $t('qty_units') }}</th>
                    <th>{{ $t('amount') }}</th>
                    <th>{{ $t('responsible_worker') }}</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  <!-- TODO: modify currentRows so that the whole table was compound - 
                    all rows in all tabs and then rows for each tab on the "all" tab;
                    label in the first column in an empty row in between;
                    rows for each tab only on the other tabs -->

                  <!-- TODO: switch tabs on left and right arrows -->
                  <!-- r.header_row show only if there are other (!header_row) rows that suit search_filter-->
                  <drag-row
                    v-for="(row, row_index) in currentRows.filter(r => 
                    (r.header_row && currentRows.filter(rm => !rm.header_row && rm.group_id === r.group_id && rm.name.toLowerCase().includes(this.search_filter.toLowerCase() || '')).length)
                    || !r.header_row && r.name.toLowerCase().includes(this.search_filter.toLowerCase() || ''))"
                    class="display-buttons-on-hover"
                    :key="'storage_' + row_index"
                    :row="row"
                    :source-id="activeTab"
                    @click.stop="!row.header_row && (row.showInfoDialog = true)"
                  >
                    <td
                      :style="
                        row.header_row ? ' border-top: 0; padding: 16px;' : ''
                      "
                    >
                      {{ !row.header_row ? row.idx + "." : "" }} {{ row.name }}
                    </td>
                    <td
                      :colspan="row.header_row ? 4 : 1"
                      :style="
                        row.header_row ? 'border-left: 0; border-top: 0;' : ''
                      "
                    >
                      {{ !row.header_row ? row.qty : "" }}
                    </td>
                    <td v-if="!row.header_row">{{ row.sum }}</td>
                    <td v-if="!row.header_row">{{ row.responsible }}</td>
                    <td v-if="!row.header_row">
                      <div class="row no-wrap">
                        <q-btn
                          flat
                          dense
                          round
                          size="10px"
                          icon="edit"
                          color="primary"
                          @click.stop="row.showInfoDialog = true"
                        >
                        </q-btn>
                        <q-btn
                          :disable="Number(row.qty) > 0"
                          flat
                          dense
                          round
                          size="10px"
                          :icon="deleteIconName"
                          color="grey-6"
                          @click.stop
                        >
                          <q-tooltip v-if="row.qty > 0">
                            {{ $t('cannot_delete_warehouse_with_goods') }}
                          </q-tooltip>
                          <q-menu v-if="Number(row.qty) <= 0">
                            <q-card>
                              <q-card-section class="row items-center">
                                <q-avatar
                                  icon="delete"
                                  size="md"
                                  color="grey"
                                  text-color="white"
                                />
                                <span class="q-ml-sm">
                                  {{ $t("sure_delete") }}
                                </span>
                              </q-card-section>

                              <q-card-actions align="right">
                                <q-btn
                                  size="sm"
                                  flat
                                  :label="$t('cancel')"
                                  color="dark"
                                  :ref="'cancelbtn'"
                                  v-close-popup
                                />
                                <q-btn
                                  size="sm"
                                  flat
                                  :label="$t('remove')"
                                  autofocus
                                  color="dark"
                                  :ref="'okbtn'"
                                  @click="removeStorage(row.id)"
                                  v-close-popup
                                />
                              </q-card-actions>
                            </q-card>
                          </q-menu>
                        </q-btn>
                      </div>
                    </td>
                    <q-dialog v-model="row.showInfoDialog" :full-width="false">
                      <storage-info-component
                        :current-storage="row.source_storage"
                        :storage-group-id="row.current_group_id"
                        :edit-name-on-start="row.openNameEditing"
                        @close="row.showInfoDialog = false"
                      />
                    </q-dialog>
                  </drag-row>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </dnd-provider>
    </div>
  </q-card>
</template>

<script lang="ts">
import { Component, Vue, Watch } from "vue-facing-decorator";
// @ts-ignore
import DropZone from "./DropZone.vue";
// @ts-ignore
import DragRow from "./DragRow.vue";
import { DndProvider } from "vue3-dnd";
import { storageStore } from "../../../store/storage/storage-instances";
import { StorageGroupWithFigures, StorageWithFigures } from "../../../models/interfaces/storage/storage-models";
import { CommonEntity } from "../../../models/interfaces/common";
import { reactive } from "vue";
import _ from "lodash";
import NativeInput from "../../common/basic/NativeInput.vue";
import StorageInfoComponent from "./info-dialogs/StorageInfoComponent.vue";

interface Row {
  id: number;
  idx?: number;
  name: string;
  responsible: string;
  qty: number;
  sum: number;
  header_row: boolean;
  current_group_id: number,
  source_storage: StorageWithFigures;
  showInfoDialog: boolean;
  openNameEditing: boolean;
  group_id: number;
}
interface Tab {
  id: string;
  dbId: number;
  label: string;
  rows: Row[];
  rows_count: number;
}

@Component({
  components: { DropZone, DragRow, DndProvider, NativeInput, StorageInfoComponent },
  emits: ["close"],
})
export default class StoragesEditComponent extends Vue {
  private editIconUrl: string = require("@/assets/icon-edit.svg");
  // вычисляемое свойство, которое Quasar ожидает в виде строки "img:URL"
  get editIconName(): string {
    return `img:${this.editIconUrl}`;
  }

  private deleteIconUrl: string = require("@/assets/icon-delete.svg");
  // вычисляемое свойство, которое Quasar ожидает в виде строки "img:URL"
  get deleteIconName(): string {
    return `img:${this.deleteIconUrl}`;
  }

  tabs: Tab[] = reactive([]);
  activeTab = "";
  // Держим локальные optimistic-переименования групп, чтобы UI не откатывался до ответа API.
  pendingGroupRenameById: Record<number, string> = reactive({});
  confirmedGroupNameById: Record<number, string> = reactive({});

  storage: any = undefined;
  // dynamic item refs
  inputs: any[] = reactive([]);
  search_filter: string = '';

  HTML5Backend = require("react-dnd-html5-backend").HTML5Backend;
  _WINDOW_ = window;

  get currentRows(): Row[] {
    return this.tabs.find((t) => t.id === this.activeTab)?.rows || [];
  }

  created() {
    this.storage = storageStore();
    this.search_filter = '';
  }

  @Watch("storagesMutated", { deep: true })
  mounted() {
    this.refreshStorages();
  }

  focusInput(level: number, pos_start = false) {
    if (this.inputs[level]) {
      // @ts-ignore
      // this.inputs[level].focus();
      this.inputs[level].startEdit();
      // if (pos_start) {
      //   this.inputs[level].nativeEl.selectionStart = 0;
      //   this.inputs[level].nativeEl.selectionEnd = 0;
      // }
    }
  }

  get storagesMutated() {
    if (!this.storage) {
      return [];
    }
    return _.cloneDeep(this.storage.storagesWithFigures);
  }

  refreshStorages() {
    // all
    this.tabs = reactive(
      this.storage.storagesWithFigures.map((group: StorageGroupWithFigures) => {
        const pendingLabel = this.pendingGroupRenameById[group.Id];
        const displayLabel = pendingLabel || group.Name;
        this.confirmedGroupNameById[group.Id] = group.Name;
        if (pendingLabel && pendingLabel === group.Name) {
          delete this.pendingGroupRenameById[group.Id];
        }

        return {
          id: "tab_group_" + group.Id,
          dbId: group.Id,
          label: displayLabel,
          rows: group.Storages.map((storage, s_index) => {
            return {
              id: storage.Id,
              name: storage.Name,
              responsible: storage.ResponsibleWorker.Name,
              qty: storage.UnitsNumber,
              sum: storage.UnitsSumTotal,
              header_row: false,
              idx: s_index + 1,
              current_group_id: group.Id,
              source_storage: storage,
              showInfoDialog: false,
              openNameEditing: false,
              group_id: group.Id
            } as Row;
          }),
          rows_count: group.Storages.length,
        } as Tab;
      })
    );

    const all_tab_index = this.storage.storagesWithFigures.findIndex(
      (g: CommonEntity) => g.Id <= 0
    );
    if (all_tab_index >= 0) {
      let s_index: number = this.tabs[all_tab_index].rows.length;

      const other_tabs = this.storage.storagesWithFigures.filter(
        (g: CommonEntity) => g.Id > 0
      );
      for (let gt = 0; gt < other_tabs.length; gt++) {
        const groupHeaderName = this.pendingGroupRenameById[other_tabs[gt].Id] || other_tabs[gt].Name;
        
        this.tabs[all_tab_index].rows.push({
          id: 0,
          name: groupHeaderName,
          responsible: "",
          qty: 0,
          sum: 0,
          header_row: true,
          group_id: other_tabs[gt].Id
        } as Row);

        for (let g_row = 0; g_row < other_tabs[gt].Storages.length; g_row++) {
          this.tabs[all_tab_index].rows.push({
            id: other_tabs[gt].Storages[g_row].Id,
            name: other_tabs[gt].Storages[g_row].Name,
            responsible: other_tabs[gt].Storages[g_row].ResponsibleWorker.Name,
            qty: other_tabs[gt].Storages[g_row].UnitsNumber,
            sum: other_tabs[gt].Storages[g_row].UnitsSumTotal,
            header_row: false,
            idx: s_index + 1,
            current_group_id: other_tabs[gt].Id,
            source_storage: other_tabs[gt].Storages[g_row],
            showInfoDialog: false,
            openNameEditing: false,
            group_id: other_tabs[gt].Id
          } as Row);
          s_index++;
        }
      }

      // "All" tab counter must show total storages count (exclude group header rows)
      this.tabs[all_tab_index].rows_count = this.tabs[all_tab_index].rows.filter(
        (r) => !r.header_row
      ).length;
    }

    if (this.tabs && this.tabs.length && !this.activeTab) {
      this.activeTab = this.tabs[0].id;
    }
  }

  async addStorage() {
    const new_one = await this.storage.createStorage();
    console.log(new_one);

    // refresh in store (figures + lists for movement selectors)
    await this.storage.getStoragesWithFigures();
    await this.storage.getStoragesWithItems();

    const all_tab_index = this.storage.storagesWithFigures.findIndex(
      (g: CommonEntity) => g.Id <= 0
    );
    if (new_one && all_tab_index >= 0) {
      const all_tab_rows = this.tabs[all_tab_index].rows;
      this.activeTab = this.tabs[all_tab_index].id;

      for (let cs = 0; cs < all_tab_rows.length; cs++) {
        if (all_tab_rows[cs].id === new_one.Id) {
          all_tab_rows[cs].showInfoDialog = true;
          all_tab_rows[cs].openNameEditing = true;
        }
      }
    }
  }

  async addStorageGroup() {
    const new_one = await this.storage.createStorageGroup();
    console.log(new_one);

    // refresh in store
    await this.storage.getStoragesWithFigures();

    if (new_one) {
      const new_tab_index = this.storage.storagesWithFigures.findIndex(
        (g: CommonEntity) => g.Id == new_one.Id
      );

      // index = 0 at all_tabs so the condition here is > 0
      if (new_tab_index > 0) {
        await this.$nextTick();
        await this.$nextTick();
        this.focusInput(new_tab_index);
      }
    }
  }

  async removeStorage(storage_id: number) {
    if (storage_id > 0) {
      await this.storage.deleteStorage(storage_id);
      // refresh in store (figures + lists for movement selectors)
      await this.storage.getStoragesWithFigures();
      await this.storage.getStoragesWithItems();
    }
  }

  close() {
    this.$emit("close", null);
  }

  async onRenameGroup(group_id: number, val: string) {
    if (group_id <= 0 || !val) return;

    const normalized = val.replace(/(\r\n|\n|\r)/g, "");
    if (!normalized) return;

    const tab = this.tabs.find((t) => t.dbId === group_id);
    const confirmedName = this.confirmedGroupNameById[group_id] || tab?.label || "";
    const pendingName = this.pendingGroupRenameById[group_id];
    if (normalized === confirmedName || normalized === pendingName) {
      return;
    }
    if (pendingName) {
      return;
    }

    this.pendingGroupRenameById[group_id] = normalized;
    if (tab) {
      tab.label = normalized;
    }

    const response = await this.storage.editStorageGroup({
      Id: group_id,
      NewName: normalized,
    });

    if (!response?.response_ok) {
      delete this.pendingGroupRenameById[group_id];
      if (tab) {
        tab.label = confirmedName;
      }
      return;
    }

    // refresh in store
    this.storage.getStoragesWithFigures();
  }

  async onDeleteGroup(group_id: number) {
    if (group_id > 0) {
      await this.storage.deleteStorageGroup(group_id);
      // refresh in store
      this.storage.getStoragesWithFigures();
    }
  }

  async moveRow(sourceId: string, targetId: string, row: Row) {
    // if (sourceId === targetId) return;
    const source = this.tabs.find((t) => t.id === sourceId);
    const target = this.tabs.find((t) => t.id === targetId);
    if (!source || !target) return;

    const idx = source.rows.findIndex((r) => r.id === row.id);
    if (idx === -1) return;

    // source.rows.splice(idx, 1);
    // target.rows.push(row);

    if (row.id === target.dbId) { return }

    if (target.dbId >= 0) {
      await this.storage.addStorageToGroup(row.id, target.dbId);
    } else {
      await this.storage.removeStorageFromGroup(row.id);
    }
    // refresh in store
    this.storage.getStoragesWithFigures();
  }
}
</script>

<style lang="scss">
.dnd-table-tabs {
  padding: $h-padding $v-padding;
}

.tab-headers {
  display: flex;
  overflow-x: auto;
  gap: 6px;
  margin-bottom: 1rem;
}

.tab-content {
  width: 100%;
}

.block-content {
  width: 100%;
  padding: $h-padding $v-padding;
}

.tab-header {
  padding: $h-padding $v-padding/2;
  background: white;
  border-radius: $smaller-radius $smaller-radius 0 0;
  border: 1px solid $border-color;
  cursor: pointer;
  &.active {
    border-color: $accent $accent $border-color $accent;
  }
}

.tab-header:has(.drop-hover) {
  padding: 0;
  border-color: $primary $primary $border-color $primary;
}

.drop-hover {
  color: $primary;
  border: 0;
  padding: $h-padding $v-padding/2;
  border-radius: $smaller-radius $smaller-radius 0 0;
}

.drag-row {
  cursor: grab;
  user-select: none;
  transition: opacity 0.2s;

  td {
    border-width: 0;
  }
}

.drag-row:hover {
  background: #f5f5f5;
}

.drag-row:active {
  cursor: grabbing;
}
</style>
